/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 17:22:15
 * @LastEditTime: 2020-09-27 09:38:47
 * @Description: 材料store
 */
import {
    createWater,
    getMaterials,
    getRawMaterialWithPrice,
    getSemiMaterialWithCost,
    getMaterialById,
    updateMaterial,
    createMaterial
} from '@/api/material'
import Vue from 'vue'

const state = {
    materials: [],
    totalCounts: 0
}

const getters = {
    productMateral(state) {
        return state.materials.filter(x => x.type === "product")
    },
    getMaterialByType: (state) => (type) => {
        return state.materials.filter((e) => e.type === type)
    },
    semiMaterial(state) {
        return state.materials.filter(x => x.type === "semi")
    },
    rawMaterial(state) {
        return state.materials.filter(x => x.type === "raw" || x.type === "water")
    }
}

const actions = {
    async addWaterAction({
        commit
    }, payload) {
        try {
            const water = await createWater(payload);
            commit('ADDNEWMATERIAL', water.data)
        } catch (error) {
            throw error.message
        }
    },
    async getMaterialsAction({
        commit
    }, payload) {
        try {
            const res = await getMaterials(payload)
            commit('SETMATERIALS', res.data)
            return res.data.materialList
        } catch (error) {
            throw error.message
        }
    },
    async getMaterialByIdAction({
        commit
    }, payload) {
        try {
            const res = await getMaterialById(payload)
            return res.data
        } catch (error) {
            throw error.message
        }
    },
    async createMaterialAction({
        commit
    }, payload) {
        try {
            const material = await createMaterial(payload)
            commit('ADDNEWMATERIAL', material.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateMaterialAction({
        commit
    }, payload) {
        try {
            const material = await updateMaterial(payload.id, payload.data);
            commit('UPDATEMATERIAL', material.data)
        } catch (error) {
            throw error.message
        }
    },
    async getRawMaterialWithPriceAction({
        commit
    }, payload) {
        try {
            const res = await getRawMaterialWithPrice(payload.api)
            commit('SETMATERIALS', res.data)
        } catch (error) {
            throw error.message
        }
    },
    async getSemiMaterialWithCostAction({
        commit
    }, payload) {
        try {
            const res = await getSemiMaterialWithCost(payload.api)
            commit('SETMATERIALS', res.data)
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETMATERIALS(state, resData) {
        state.materials = resData.materialList
        state.totalCounts = resData.totalCounts
    },
    ADDNEWMATERIAL(state, material) {
        state.materials.unshift(material)
        state.totalCounts++
    },
    UPDATEMATERIAL(state, material) {
        Vue.set(state.materials, state.materials.findIndex(x => x._id === material._id), material)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}